/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useEffect } from 'react';
import { useField } from '@unform/core';
import { TextareaAutosize, TextareaAutosizeProps } from '@material-ui/core';

import useStyles from './styles';

interface Props extends TextareaAutosizeProps {
  name: string;
  rows: number;
  label?: string;
}

const TextArea: React.FC<Props> = ({
  name,
  rows,
  label,
  placeholder,
  ...rest
}) => {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue } = useField(name);
  const classes = useStyles();

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <TextareaAutosize
      name={name}
      ref={inputRef}
      rows={rows}
      className={classes.textarea}
      aria-label={label}
      placeholder={placeholder}
      defaultValue={defaultValue}
      {...rest}
    />
  );
};

export default TextArea;
